/*
 * GENERATED FROM THE PUBLISHED PDF REPORTS — DO NOT EDIT BY HAND.
 *
 * Source: the 41 reports in public/reports/, parsed from each report's "Findings by severity",
 * "Findings by status" and "Findings summary" tables. Every number here is read out of a report;
 * nothing is estimated. Re-generate after adding a report rather than editing this file.
 *
 * Totals: 41 reports, 333 findings
 * (18 critical, 46 high, 78 medium,
 *  112 low, 72 informational, 7 not rated).
 */

export const AUDIT_TOTALS = {
  "reports": 41,
  "findings": 333,
  "severity": {
    "critical": 18,
    "high": 46,
    "medium": 78,
    "low": 112,
    "informational": 72,
    "not_rated": 7
  },
  "status": {
    "Not recorded": 91,
    "Resolved": 163,
    "Acknowledged": 53,
    "Open": 26
  }
};

/* The six most recent reports, for the homepage strip. Full list: src/data/auditReports.js */
export const LATEST_REPORTS = [
  {
    "id": "private-client-not-disclosed-ai-agent-review",
    "client": "Private client (not disclosed)",
    "scope": "AI Agent Review",
    "platform": "Web3 AI agent platform (LLM planner, MCP tools, RAG, on-chain wallet)",
    "language": "Python (examples)",
    "date": "Aug 2026",
    "severity": {
      "critical": 1,
      "high": 4,
      "medium": 5,
      "low": 4,
      "informational": 0,
      "not_rated": 0
    },
    "total": 14,
    "status": {
      "Not recorded": 14
    },
    "pdf": "/reports/private-client-not-disclosed-ai-agent-review.pdf"
  },
  {
    "id": "private-client-not-disclosed-ai-and-mcp-review",
    "client": "Private client (not disclosed)",
    "scope": "AI and MCP Review",
    "platform": "Web3 AI agent platform (LLM planner, MCP tools, RAG, on-chain wallet)",
    "language": "Python (examples)",
    "date": "Aug 2026",
    "severity": {
      "critical": 1,
      "high": 2,
      "medium": 3,
      "low": 1,
      "informational": 0,
      "not_rated": 0
    },
    "total": 7,
    "status": {
      "Not recorded": 7
    },
    "pdf": "/reports/private-client-not-disclosed-ai-and-mcp-review.pdf"
  },
  {
    "id": "snpit-mobile-app",
    "client": "SNPIT",
    "scope": "Mobile App",
    "platform": "iOS and Android (Flutter)",
    "language": "Dart",
    "date": "Aug 2026",
    "severity": {
      "critical": 0,
      "high": 1,
      "medium": 0,
      "low": 1,
      "informational": 4,
      "not_rated": 0
    },
    "total": 6,
    "status": {
      "Not recorded": 6
    },
    "pdf": "/reports/snpit-mobile-app.pdf"
  },
  {
    "id": "clique-svm-v2-lock-hook-and-streams",
    "client": "Clique",
    "scope": "SVM V2 Lock Hook and Streams",
    "platform": "SVM",
    "language": "Rust (Anchor)",
    "date": "Jan 2026",
    "severity": {
      "critical": 0,
      "high": 0,
      "medium": 3,
      "low": 7,
      "informational": 5,
      "not_rated": 0
    },
    "total": 15,
    "status": {
      "Not recorded": 15
    },
    "pdf": "/reports/clique-svm-v2-lock-hook-and-streams.pdf"
  },
  {
    "id": "axios-finance-lending-markets",
    "client": "Axios Finance",
    "scope": "Lending Markets",
    "platform": "Fuel",
    "language": "Sway",
    "date": "Dec 2025",
    "severity": {
      "critical": 3,
      "high": 1,
      "medium": 0,
      "low": 2,
      "informational": 3,
      "not_rated": 0
    },
    "total": 9,
    "status": {
      "Resolved": 7,
      "Acknowledged": 1,
      "Open": 1
    },
    "pdf": "/reports/axios-finance-lending-markets.pdf"
  },
  {
    "id": "clique-sui-distributor",
    "client": "Clique",
    "scope": "Sui Distributor",
    "platform": "Sui",
    "language": "Move",
    "date": "Dec 2025",
    "severity": {
      "critical": 0,
      "high": 2,
      "medium": 2,
      "low": 5,
      "informational": 3,
      "not_rated": 0
    },
    "total": 12,
    "status": {
      "Not recorded": 12
    },
    "pdf": "/reports/clique-sui-distributor.pdf"
  }
];
